import React from 'react';

import App from 'screens/Root';

import 'scss/theme-dark.scss';

const Theme = () => (
    <React.Fragment>
        <App/>
    </React.Fragment>
);

export default Theme;